import { axios } from "utils";

import { ADMIN_CHANGE_EVENTS_URL as endpoint } from "consts";

import { ChangeEventTimeline } from "models";

export const getFieldChangeTimeline = async ({ fieldId, year }: { fieldId: string; year?: number | null }): Promise<ChangeEventTimeline> =>
  axios.get(`${endpoint}/fields/${fieldId}${year ? `?year=${year}` : ""}`);
